import { useMemo } from 'react';

import { DetailRowProps } from '../../types/DetailRowProps';
import { getDetailValue } from './logic/getDetailValue';
import { getFontWeight } from './logic/getFontWeight';

export const useDetailRow = (
  amount: DetailRowProps['amount'],
  highlight: DetailRowProps['highlight'],
  bold: DetailRowProps['bold'],
  percent: DetailRowProps['percent'],
) => {
  const fontWeight = useMemo(
    () => getFontWeight(highlight, bold),
    [bold, highlight],
  );
  const value = useMemo(
    () => getDetailValue(amount, percent),
    [amount, percent],
  );

  return {
    fontWeight,
    value,
  };
};
